import React, { Component } from 'react'
import Vimeo from '@u-wave/react-vimeo';

class VimeoVideo extends Component {

  constructor(props) {
    super(props);

    this.state = {
      videoIndex: 0,
      volume: 0,
      paused: false,
      isActive: false,
      isVolumeActive: false,
    };


    this.handlePause = this.handlePause.bind(this);
    this.handlePlayerPause = this.handlePlayerPause.bind(this);
    this.handlePlayerPlay = this.handlePlayerPlay.bind(this);
    this.handleVolume = this.handleVolume.bind(this);
  }

  handlePause(event) {
    this.setState({
      paused: event.target.checked,
    });
    this.setState({ isActive: !this.state.isActive });
  }

  handlePlayerPause() {
    this.setState({ paused: true });
  }

  handlePlayerPlay() {
    this.setState({ paused: false });
  }

  handleVolume(volume) {
    if(this.state.volume === 1) {
      this.setState({ volume: 0 });
    } else {
      this.setState({ volume: 1 });
    }
    this.setState({ isVolumeActive: !this.state.isVolumeActive });
  }

  selectVideo(index) {
    this.setState({ videoIndex: index });
  }

  render() {

    let { vimeoVideoId, fullwidthVideo, squareRatioVideo, backgroundcol} = this.props

    const videos = [
      { id: vimeoVideoId, name: 'StudioSmall' },
    ];

    const { videoIndex, paused, volume } = this.state;

    const video = videos[videoIndex];
    
    const isActive = this.state.isActive;
    const isVolumeActive = this.state.isVolumeActive;
    
    // console.log(volume + ' volume value');

    return (
      <div>
        {(() => {
          if (fullwidthVideo === 'enable') {
            return (
              <section className='video' style={{backgroundColor:backgroundcol}}>
     

{/* 
16-9 : sixteen-nine
4-3 : four-three
3-2 : three-two
8-5 : eight-five
Begg Square Ratio : begg-ratio
enable : Enable
disable : Disable
 */}

    <div className={squareRatioVideo === 'sixteen-nine' ? 'video-container sixteen-nine'
      : squareRatioVideo  === 'four-three' ? 'video-container four-three'
      : squareRatioVideo  === 'three-two' ? 'video-container three-two'
      : squareRatioVideo  === 'eight-five' ? 'video-container eight-five'
      : squareRatioVideo  === 'begg-ratio' ? 'video-container begg-ratio'
      : squareRatioVideo  === 'begg-aw-campaign' ? 'video-container begg-aw-campaign'
      : squareRatioVideo  === 'begg-long' ? 'video-container begg-long'
      : 'video-container'}>

                {/* <div className={squareRatioVideo  === 'enable' ? ( 'video-container begg-ratio') : ('video-container')}> */}
                {videos.map((choice, index) => (
                          <a key={index}
                            href={`#!/video/${index}`}
                            className={`collection-item ${video === choice ? 'active' : ''}`}
                            onClick={() => this.selectVideo(index)}
                          >
                          </a>
                        ))}

                      <div className='video__controls'>
                        <label htmlFor="paused">
                          <input
                            type="checkbox"
                            id="paused"
                            checked={paused}
                            onChange={this.handlePause}
                          />
                          <div className={isActive ? "play-control active" : "play-control"}>
                            <svg className='play' width="25px" height="20px" viewBox="0 0 25 33" version="1.1">
                                <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                    <g id="Information-Page" transform="translate(-934.000000, -593.000000)" fill="#fff">
                                        <polygon id="Triangle" transform="translate(946.500000, 609.500000) rotate(90.000000) translate(-946.500000, -609.500000) " points="946.5 597 963 622 930 622"></polygon>
                                    </g>
                                </g>
                            </svg>
                            <svg className='pause' width="22px" height="20px" viewBox="0 0 22 33" version="1.1">
                                <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                    <g id="Information-Page" transform="translate(-900.000000, -593.000000)" fill="#fff">
                                        <g id="Group" transform="translate(900.000000, 593.000000)">
                                            <rect id="Rectangle" x="16" y="0" width="6" height="33" rx="3"></rect>
                                            <rect id="Rectangle" x="0" y="0" width="6" height="33" rx="3"></rect>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                          </div>
                        </label>
                      
                      <div className='video__volume'>
                        <label htmlFor="volume">
                          {/* <span>Volume</span> */}
                          <input
                          type="checkbox"
                          id="volume"
                          checked={volume}
                          onChange={this.handleVolume}
                          />

                          <div className={isVolumeActive ? "volume-control active" : "volume-control"}>                          

                            <div className='sound'>
                              Mute
                            </div>

                            <div className='muted'>
                              Unmute
                            </div>
                          </div>

                        </label>
                      </div>

                      </div>

                      <Vimeo
                        video={video.id}
                        width={640}
                        height={480}
                        autoplay
                        muted
                        loop
                        controls={false}
                        volume={volume}
                        paused={paused}
                        onPause={this.handlePlayerPause}
                        onPlay={this.handlePlayerPlay}
                      />
                </div>
              </section>
            )
          } else {
            return (
              <section className='video' style={{backgroundColor:backgroundcol}}>
                <div className='video-project'>
                  <div className='video-project__contained'>
                  <div className={squareRatioVideo === 'sixteen-nine' ? 'video-container sixteen-nine'
      : squareRatioVideo  === 'four-three' ? 'video-container four-three'
      : squareRatioVideo  === 'three-two' ? 'video-container three-two'
      : squareRatioVideo  === 'eight-five' ? 'video-container eight-five'
      : squareRatioVideo  === 'begg-ratio' ? 'video-container begg-ratio'
      : squareRatioVideo  === 'begg-aw-campaign' ? 'video-container begg-aw-campaign'
      : squareRatioVideo  === 'begg-long' ? 'video-container begg-long'
      : 'video-container'}>
                        {videos.map((choice, index) => (
                          <a
                            key={index}
                            href={`#!/video/${index}`}
                            className={`collection-item ${video === choice ? 'active' : ''}`}
                            onClick={() => this.selectVideo(index)}
                          >
                          </a>
                        ))}

                      <div className='video__controls'>
                        <label htmlFor="paused">
                          <input
                            type="checkbox"
                            id="paused"
                            checked={paused}
                            onChange={this.handlePause}
                          />
                          <div className={isActive ? "play-control active" : "play-control"}>
                            <svg className='play' width="25px" height="20px" viewBox="0 0 25 33" version="1.1">
                                <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fill-rule="evenodd">
                                    <g id="Information-Page" transform="translate(-934.000000, -593.000000)" fill="#fff">
                                        <polygon id="Triangle" transform="translate(946.500000, 609.500000) rotate(90.000000) translate(-946.500000, -609.500000) " points="946.5 597 963 622 930 622"></polygon>
                                    </g>
                                </g>
                            </svg>

                            <svg className='pause' width="22px" height="20px" viewBox="0 0 22 33" version="1.1">
                                <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fill-rule="evenodd">
                                    <g id="Information-Page" transform="translate(-900.000000, -593.000000)" fill="#fff">
                                        <g id="Group" transform="translate(900.000000, 593.000000)">
                                            <rect id="Rectangle" x="16" y="0" width="6" height="33" rx="3"></rect>
                                            <rect id="Rectangle" x="0" y="0" width="6" height="33" rx="3"></rect>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                          </div>
                        </label>

                        <div className='video__volume'>
                        <label htmlFor="volume">
                          {/* <span>Volume</span> */}
                          <input
                          type="checkbox"
                          id="volume"
                          checked={volume}
                          onChange={this.handleVolume}
                          />

                          <div className={isVolumeActive ? "volume-control active" : "volume-control"}>                          
                            <div className='sound'>
                              Mute
                            </div>

                            <div className='muted'>
                              Unmute
                            </div>
                          </div>

                        </label>
                      </div>

                      </div>

                      <Vimeo
                        video={video.id}
                        width={640}
                        height={480}
                        autoplay
                        muted
                        loop
                        controls={false}
                        volume={volume}
                        paused={paused}
                        onPause={this.handlePlayerPause}
                        onPlay={this.handlePlayerPlay}
                      />
                    </div>
                  </div>
                </div>
              </section>
            )
          }
        })()}
      </div>
    )
  }
}

export default VimeoVideo












// import React, { Component } from 'react'

// import Plyr from '../components/plyr'
// // import { GatsbyImage, getImage } from 'gatsby-plugin-image'

// class VimeoVideo extends Component {

//   render() {

//   	let { vimeoVideoId, fullwidthVideo} = this.props

//     //this.player.setVolume(5)

//     return (

//       <div>
//         {(() => {
//           if (fullwidthVideo === 'enable') {
//             return (
//               <section className='video'>
//                 <Plyr
//                   type='vimeo'
//                   ref='player'
//                   videoId={ vimeoVideoId }
//                   // volume={5}
//                   controls={ ['play', 'volume', 'mute'] }
//                   urls={{
//                     vimeo: {
//                       api: 'https://noembed.com/embed?url={0}?background=1'
//                     }
//                   }}
//                 />
//             </section>
//             )
//           } else {
//             return (
//               <section className='video'>
//               <div className='video-project'>
//               <div className='video-project__contained'>
//                 <Plyr
//                   type='vimeo'
//                   ref='player'
//                   videoId={ vimeoVideoId }
//                   // volume={5}
//                   controls={ ['play', 'volume', 'mute'] }
//                   urls={{
//                     vimeo: {
//                       api: 'https://noembed.com/embed?url={0}?background=1'
//                     }
//                   }}
//                 />
//               </div>
//             </div>
//             </section>
//             )
//           }
//         })()}
//       </div>
//     )
//   }
// }

// export default VimeoVideo


